import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Visibility } from "@mui/icons-material";
import { setSelectedUser } from "../../store/slices/userSlice";
import AssignPersonDialog from "../dialogs/AssignPersonDialog";
import { useSalesPersons } from "../../hooks/usePersonsData";
import { RootState } from "../../store";
import { useRegisterFabAction } from "../action-sidebar/FabActionsContext";

const FabEyeButton: React.FC = () => {
  const dispatch = useDispatch();
  const selectedUserId = useSelector(
    (state: RootState) => state.user.selectedUserId
  );
  const [modalOpen, setModalOpen] = useState(false);
  const [fabSelectedUser, setFabSelectedUser] = useState<number | null>(
    selectedUserId
  );
  const { persons, isLoading } = useSalesPersons();

  const selectedUserName =
    fabSelectedUser && persons
      ? persons.find((p) => p.id === fabSelectedUser)?.name
      : null;

  useRegisterFabAction({
    id: "select-user",
    label: selectedUserName ?? "Välj användare",
    icon: <Visibility />,
    onClick: () => setModalOpen(true),
    priority: 5,
  });

  const handleUserSelect = async (user: number | null) => {
    setFabSelectedUser(user);
    dispatch(setSelectedUser(user));
    setModalOpen(false);
  };

  return (
    <AssignPersonDialog
      open={modalOpen}
      onClose={() => setModalOpen(false)}
      onAssign={handleUserSelect}
      label="Välj användare"
      persons={persons}
      title="Välj användare"
      currentPersonId={fabSelectedUser}
      isLoading={isLoading}
      allowClear={true}
      clearLabel="Ingen användare vald"
    />
  );
};

export default FabEyeButton;
